/*
 * @Description: 
 * @Date: 2019-10-24 10:58:17
 * @LastEditors: Ji Yinghao
 * @LastEditTime: 2019-10-30 18:47:17
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import vuetify from './plugins/vuetify';
import axios from './axios';
import Cookie from './serves/cookies.js';
import Apis from "./serves/api.js";
import * as filters from './serves/filter.js';
// import VueSocketIO from 'vue-socket.io';

// 提示框组件
import getProductCheckResult from "./components/promptBox/promptBox.js";
Vue.use(getProductCheckResult);

Vue.config.productionTip = false
Vue.prototype.$apis = Apis;
Vue.prototype.$cookie = Cookie;

// 全局全部过滤器
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key]);
});
// Socket
// Vue.use(new VueSocketIO({
//     debug: true,
//     connection: 'wss://www.hiensor.net:10443',
//     options: { path: "/api/v1/ws" } //Optional options
// }))

new Vue({
    router,
    axios,
    vuetify,
    render: h => h(App)
}).$mount('#app')